import { PrimitiveAtom, WritableAtom } from "jotai";
import { splitAtom } from "jotai/utils";

// Not exported, copy
type SplitAtomActionExt<Item> =
    | {
          type: "remove";
          atom: PrimitiveAtom<Item>;
      }
    | {
          type: "insert";
          value: Item;
          before?: PrimitiveAtom<Item>;
      }
    | {
          type: "move";
          atom: PrimitiveAtom<Item>;
          before?: PrimitiveAtom<Item>;
      };
// Not extremely proud to think it works to extend the signature without even a cast.
const splitAtomExt: <Item, Key, Result>(
    arrAtom: WritableAtom<Item[], [Item[]], Result>,
    keyExtractor?: (item: Item) => Key
) => WritableAtom<
    PrimitiveAtom<Item>[],
    [SplitAtomActionExt<Item>],
    /*Is it Result ? void ?*/ unknown
> = splitAtom;

export { type SplitAtomActionExt, splitAtomExt };
